import * as types from '../action/types'

const initialState = null

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_EMITENT_ID:
      return action.emitentId
    default:
      return state
  }
}
